/* eslint-disable max-len */
import React, {createElement, useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ReactComponent as iconBicisWhite} from '../../assets/icons/transports/transporte-bici-white.svg';

import {ReactComponent as iconBicisDark} from '../../assets/icons/transports/transporte-bici.svg';
import {ReactComponent as iconCochesWhite} from '../../assets/icons/transports/transporte-coche-white.svg';
import {ReactComponent as iconCochesDark} from '../../assets/icons/transports/transporte-coche.svg';
import {ReactComponent as iconMotosWhite} from '../../assets/icons/transports/transporte-moto-white.svg';
import {ReactComponent as iconMotosDark} from '../../assets/icons/transports/transporte-moto.svg';
import {themeOptions} from '../../utils/utils';
import {TransportListComponent} from '../transport-list/transport-list.component';

import './accordion.scss';
import {NoParkingLegend} from './no-parking-legend';

function AccordionFilterGroupComponent(props: any) {
    const {t} = useTranslation();
    const theme = localStorage.getItem('theme');
    const content = useRef(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const [visible, setVisible] = useState(false);


    const toggleAccordion = (index: any) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
        setVisible(true);
    };

    useEffect(() => {
        localStorage.getItem('theme');
    }, [theme]);


    return (
        <div className="shared-transports-list">
            {props.items.map((item: any, index: number) => (
                <div key={index} className="accordion__section accordion_filter">
                    <button className={`accordion ${activeIndex === index ? 'active' : ''}`} onClick={() => toggleAccordion(index)}>
                        <div className="accordion__section_single">
                            {item.name == t('translation:web_show_map_icon_bici') && (theme === themeOptions[1]) ? createElement(iconBicisWhite) : ''}
                            {item.name == t('translation:web_show_map_icon_car') && (theme === themeOptions[1]) ? createElement(iconCochesWhite) : ''}
                            {item.name == t('translation:web_show_map_icon_moto') && (theme === themeOptions[1]) ? createElement(iconMotosWhite) : ''}

                            {item.name == t('translation:web_show_map_icon_bici') && (theme === themeOptions[0]) ? createElement(iconBicisDark) : ''}
                            {item.name == t('translation:web_show_map_icon_car') && (theme === themeOptions[0]) ? createElement(iconCochesDark) : ''}
                            {item.name == t('translation:web_show_map_icon_moto') && (theme === themeOptions[0]) ? createElement(iconMotosDark) : ''}
                            <p className="accordion__title">{item.name}</p>
                        </div>
                        <svg
                            className={`${activeIndex === index ? 'rotate' : ''}`}
                            width="1rem"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 14 9"
                        >
                            <defs>
                                <filter id="5u5eagi6aa">
                                    <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.855826 0 0 0 0 0.195840 0 0 0 0 0.165660 0 0 0 1.000000 0"/>
                                </filter>
                            </defs>
                            <g fill="none">
                                <g filter="url(#5u5eagi6aa)" transform="translate(-341 -166)">
                                    <g>
                                        {/* eslint-disable-next-line */}
                                    <path
                                            fill="#A8A19B"
                                            d="M10.832 3.257L5.008-2.567c-.46-.46-1.204-.46-1.663 0-.46.46-.46 1.204 0 1.664l4.991 4.991L3.345 9.08c-.46.46-.46 1.205 0 1.664.459.46 1.204.46 1.663 0l5.824-5.824c.46-.458.46-1.203 0-1.663z"
                                            transform="translate(341 166.412) rotate(90 7.088 4.088)"/>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </button>
                    {activeIndex === index && visible &&
                        <div ref={content} style={{maxHeight: `${activeIndex === index ? '500px' : '0px'}`}} className="accordion__content_container">
                            <div className="accordion__text">
                                <div className="content-container">
                                    <TransportListComponent transports={props.items[index].transports}/>
                                    {item.name == t('translation:web_show_map_icon_moto') && ( <NoParkingLegend />)}
                                </div>
                            </div>
                        </div>}
                </div>
            ))}
        </div>
    );
}

export default AccordionFilterGroupComponent;
